/**
 * Constants for block menu analytics menu item names
 */
export const BLOCK_MENU_ITEM_NAME = {
	COPY_LINK_TO_BLOCK: 'copyLinkToBlock',
	MOVE_UP: 'moveUp',
	MOVE_DOWN: 'moveDown',
	DELETE: 'delete',
	FORMAT_MENU: 'formatMenu',
} as const;
